/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { Navigate } from 'react-router-dom';
import NotFound from 'components/Error404';
import { PermissionLevel, ServicePermissions } from 'components/Project/types/enums';
import { usePermission } from 'hooks/use-permission';

interface RequirePermissionProps {
  children: React.ReactNode;
  service: ServicePermissions;
  access?: PermissionLevel;
  redirectTo?: string;
}

const RequirePermission = ({
  children,
  service,
  access = PermissionLevel.READ,
  redirectTo = '/',
}: RequirePermissionProps) => {
  const {
    hasPermission,
    isReadPermission,
    isWritePermission,
  } = usePermission();

  if (!hasPermission(service)) {
    return <Navigate to={redirectTo} replace />;
  }

  if (access === PermissionLevel.READ) {
    if (isReadPermission(service) || isWritePermission(service)) {
      return <>{children}</>;
    }
  }

  if (access === PermissionLevel.WRITE) {
    if (isWritePermission(service)) {
      return <>{children}</>;
    }
    return <Navigate to={redirectTo} replace />;
  }

  return <NotFound />;
};

export default RequirePermission;
